/* Generated native wrapper: selectors cannot touch the storefront. */
(() => {
 'use strict';
 const reader = document.querySelector('[data-bk-bebrininkai]');
 if (!reader || reader.dataset.nativeReady === 'true') return;
 reader.dataset.nativeReady = 'true';
 const readerId = id => id ? reader.querySelector('#' + CSS.escape(id)) : null;
'use strict';
// Progressive enhancement: every historical stop remains readable without JavaScript.
const choices = [...reader.querySelectorAll('[data-year]')];
const panels = [...reader.querySelectorAll('.time-panel')];
function selectYear(id) {
  if (!panels.some(panel => panel.id === id)) return;
  panels.forEach(panel => { panel.hidden = panel.id !== id; });
  choices.forEach(choice => {
    if (choice.hash === `#${id}`) choice.setAttribute('aria-current', 'true');
    else choice.removeAttribute('aria-current');
  });
}
choices.forEach(choice => choice.addEventListener('click', event => {
  event.preventDefault();
  selectYear(choice.hash.slice(1));
  history.replaceState(null, '', choice.hash);
  syncLanguageLinks();
}));
window.addEventListener('hashchange', () => {
 selectYear(location.hash.slice(1));
 syncLanguageLinks();
});
selectYear(location.hash.startsWith('#metai-') ? location.hash.slice(1) : 'metai-1578');
const dialog = reader.querySelector('#image-dialog');
const photo = reader.querySelector('#dialog-photo');
const caption = reader.querySelector('#image-caption');
let lastTrigger;
if (typeof dialog.showModal === 'function') {
 reader.querySelectorAll('[data-image]').forEach(button => {
  button.dataset.ready = 'true';
  button.addEventListener('click', event => {
   event.preventDefault();
   const original = button.querySelector('img');
   photo.width = original.naturalWidth || Number(original.getAttribute('width')) || 1280;
   photo.height = original.naturalHeight || Number(original.getAttribute('height')) || 960;
   photo.src = button.getAttribute('href');
   photo.alt = original.alt;
   reader.querySelector('#image-title').textContent = button.dataset.photoTitle;
   caption.textContent = button.closest('figure').querySelector('figcaption').textContent;
   lastTrigger = button;
   dialog.showModal();
  });
 });
 reader.querySelector('#close-dialog').addEventListener('click', () => dialog.close());
 dialog.addEventListener('close', () => lastTrigger?.focus());
 dialog.addEventListener('click', event => {
  const box = dialog.getBoundingClientRect();
  if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
 });
}
// Credit links are written as static HTML by the builder; no network or tracking is used.

// Language changes preserve a shared chapter/history fragment; plain links also work offline.
const languageLinks = [...reader.querySelectorAll('.language-switch a')];
function syncLanguageLinks() {
 languageLinks.forEach(link => {
  const page = link.getAttribute('href').split('#')[0];
  link.setAttribute('href', page + (readerId(location.hash.slice(1)) ? location.hash : ''));
 });
}
syncLanguageLinks();

// Progressive visual exploration. Native disclosures and full historical prose remain without JS.
const habitatNotes = [...reader.querySelectorAll('[data-habitat-note]')];
const habitatMarkers = [...reader.querySelectorAll('[data-habitat-target]')];
function syncHabitatMarkers() {
  habitatMarkers.forEach(marker => {
    const note = readerId(`habitat-${marker.dataset.habitatTarget}`);
    marker.setAttribute('aria-pressed', String(Boolean(note?.open)));
  });
}
habitatMarkers.forEach(marker => {
  marker.hidden = false;
  marker.addEventListener('click', () => {
    habitatNotes.forEach(note => { note.open = note.dataset.habitatNote === marker.dataset.habitatTarget; });
    syncHabitatMarkers();
  });
});
habitatNotes.forEach(note => note.addEventListener('toggle', syncHabitatMarkers));
syncHabitatMarkers();

const duesGroup = reader.querySelector('.dues-tokens');
const duesResult = reader.querySelector('#dues-result');
if (duesGroup && duesResult) {
  duesGroup.hidden = false;
  const duesChoices = [...duesGroup.querySelectorAll('[data-dues]')];
  duesChoices.forEach(choice => choice.addEventListener('click', () => {
    duesChoices.forEach(item => item.setAttribute('aria-pressed', String(item === choice)));
    duesResult.textContent = choice.dataset.dues === 'estate' ? duesResult.dataset.estateText : duesResult.dataset.keeperText;
  }));
}

// Append after flow.js. Existing habitat and obligation handlers remain untouched.
(() => {
  'use strict';

  reader.querySelectorAll('.beaver-notebook').forEach(notebook => {
    const markers = [...notebook.querySelectorAll('[data-anatomy-target]')];
    const notes = [...notebook.querySelectorAll('[data-anatomy-part]')];
    if (!markers.length || markers.some(marker => !notes.some(note => note.id === marker.getAttribute('aria-controls')))) return;
    if (notebook.dataset.anatomyReady === 'true') return;
    notebook.dataset.anatomyReady = 'true';
    const sync = () => markers.forEach(marker => {
      const note = notes.find(item => item.id === marker.getAttribute('aria-controls'));
      marker.setAttribute('aria-expanded', String(note.open));
    });
    markers.forEach(marker => {
      marker.addEventListener('click', () => {
        notes.forEach(note => { note.open = note.id === marker.getAttribute('aria-controls'); });
        sync();
      });
      marker.hidden = false;
    });
    notes.forEach(note => note.addEventListener('toggle', sync));
    sync();
  });

  const motionPreference = typeof window.matchMedia === 'function'
    ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  reader.querySelectorAll('[data-tail-demo]').forEach(demo => {
    const play = demo.querySelector('[data-tail-play]');
    const status = demo.querySelector('[data-tail-status]');
    if (!play || !status || demo.dataset.tailReady === 'true') return;
    demo.dataset.tailReady = 'true';
    let timers = [];
    let hasPlayed = false;
    const label = text => {
      // Keep the decorative replay glyph outside the accessible button name.
      play.replaceChildren(document.createTextNode(text));
      const glyph = document.createElement('span');
      glyph.setAttribute('aria-hidden', 'true');
      glyph.textContent = '↻';
      play.append(glyph);
    };
    const stop = () => {
      timers.forEach(timer => window.clearTimeout(timer));
      timers = [];
      demo.classList.remove('is-playing');
      play.removeAttribute('aria-busy');
    };
    const showStatic = () => {
      stop();
      status.textContent = motionPreference?.matches ? demo.dataset.reducedText : demo.dataset.staticText;
      label(hasPlayed ? play.dataset.replayLabel : play.dataset.playLabel);
    };
    play.addEventListener('click', () => {
      stop();
      hasPlayed = true;
      label(play.dataset.replayLabel);
      if (motionPreference?.matches) {
        showStatic();
        return;
      }
      // A user-triggered layout read lets the same finite CSS sequence replay.
      void demo.offsetWidth;
      demo.classList.add('is-playing');
      play.setAttribute('aria-busy', 'true');
      status.textContent = demo.dataset.liftingText;
      timers.push(window.setTimeout(() => { status.textContent = demo.dataset.impactText; }, 1350));
      timers.push(window.setTimeout(() => {
        stop();
        label(play.dataset.replayLabel);
        status.textContent = demo.dataset.completeText;
      }, 3100));
    });
    const disclosure = demo.closest('details');
    disclosure?.addEventListener('toggle', () => { if (!disclosure.open) showStatic(); });
    if (motionPreference?.addEventListener) motionPreference.addEventListener('change', showStatic);
    else if (motionPreference?.addListener) motionPreference.addListener(showStatic);
    // Install every handler before revealing the enhancement-only button.
    if (motionPreference?.matches) status.textContent = demo.dataset.reducedText;
    play.hidden = false;
  });
})();

// The three work markers share native statute disclosures as their source of truth.
(() => {
  'use strict';
  reader.querySelectorAll('.statute-river').forEach(section => {
    const markers = [...section.querySelectorAll('[data-law-target]')];
    const notes = [...section.querySelectorAll('[data-law-note]')];
    if (markers.length !== 3 || notes.length !== 3) return;
    const sync = () => markers.forEach(marker => {
      const note = notes.find(item => item.id === marker.getAttribute('aria-controls'));
      marker.setAttribute('aria-expanded', String(Boolean(note?.open)));
    });
    markers.forEach(marker => {
      marker.addEventListener('click', () => {
        notes.forEach(note => { note.open = note.id === marker.getAttribute('aria-controls'); });
        sync();
      });
      marker.hidden = false;
    });
    notes.forEach(note => note.addEventListener('toggle', sync));
    sync();
  });
})();

// Photo-informed, unitless 3D teaching geometry. Replace the 18 Oct controller.
(() => {
  'use strict';
  const ns = 'http://www.w3.org/2000/svg';
  const features = ['body', 'roof', 'entry', 'gallery', 'decoration', 'annexes'];
  const marks = [[90,205],[460,58],[155,397],[550,155],[544,342],[350,410]];
  const anchors = [[1.55,.65,1.50],[0,0,4.31],[1.76,0,1.35],[.65,0,1.90],[-1.50,0,1.60],[0,-2.62,.95]];
  reader.querySelectorAll('[data-chapel-model][data-chapel-real="v2"]').forEach(model => {
    if (model.dataset.chapelReady) return;
    const section = model.closest('[data-chapel-encyclopedia]');
    const drawing = model.querySelector('[data-chapel-drawing]');
    const leaders = model.querySelector('[data-chapel-leaders]');
    const toolbar = model.querySelector('[data-chapel-controls]');
    const roof = model.querySelector('[data-chapel-roof]');
    const status = model.querySelector('[data-chapel-status]');
    const buttons = [...model.querySelectorAll('[data-chapel-feature]')];
    const notes = features.map(feature => section?.querySelector(`[data-chapel-note="${feature}"]`));
    let mesh;
    try { mesh = JSON.parse(model.dataset.chapelMesh); } catch { return; }
    if (!drawing || !leaders || !toolbar || !roof || !status || buttons.length !== 6 || notes.some(note => !note)
      || !Array.isArray(mesh) || mesh.some(item => !Array.isArray(item.p) || !Array.isArray(item.c)
        || [item.p,...(item.q||[])].some(path=>!Array.isArray(path)||path.some(point => point.length !== 3 || point.some(n => !Number.isFinite(n)))))
      || buttons.some(button => !notes.some(note => note.id === button.getAttribute('aria-controls')))) return;
    let angle = 40, cutaway = false, selected = 'body';
    const radians = () => angle * Math.PI / 180;
    const depth = point => point[0] * Math.sin(radians()) + point[1] * Math.cos(radians());
    const project = ([x,y,z]) => [320 + (x*Math.cos(radians()) - y*Math.sin(radians()))*74,347 + depth([x,y])*29-z*58];
    const near = item => item.n ? depth(item.n) > .045 : depth(item.c) > 0;
    const order = item => item.part === 'roof' ? [4,item.band,depth(item.c)]
      : item.internal ? [2,item.band,depth(item.c)] : [near(item) ? 3 : 1,depth(item.c),0];
    const compare = (a,b) => { const x=order(a),y=order(b);return x[0]-y[0] || x[1]-y[1] || x[2]-y[2]; };
    const element = (tag,attrs) => {
      const node=document.createElementNS(ns,tag);
      Object.entries(attrs).forEach(([key,value])=>node.setAttribute(key,String(value)));
      return node;
    };
    const render = () => {
      const fragment=document.createDocumentFragment();
      mesh.filter(item=>cutaway ? item.part!=='roof' && !(item.shell && near(item)) : !item.internal).sort(compare).forEach(item=>{
        const classes=['chapel-shape',`chapel-${item.m}`];
        if (item.part===selected && !item.line && !/^(wood-|joint-end|metal-|inside-)/.test(item.m)) classes.push('is-feature');
        if (cutaway && !item.internal && item.n && near(item)) classes.push('is-ghost');
        const coordinates = path => path.map(point=>project(point).map(n=>n.toFixed(2)).join(',')).join(' ');
        const attrs={class:classes.join(' ')};
        if (item.q) attrs.d=[item.p,...item.q].map(path=>'M'+coordinates(path).replaceAll(' ',' L')).join(' ');
        else attrs.points=coordinates(item.p);
        fragment.append(element(item.q ? 'path' : item.line ? 'polyline' : 'polygon',attrs));
      });
      drawing.replaceChildren(fragment);
      const lines=document.createDocumentFragment();
      anchors.forEach((anchor,index)=>{
        const p=project(index===1 && cutaway ? [0,0,2.5] : anchor);
        lines.append(element('line',{x1:marks[index][0],y1:marks[index][1],x2:p[0].toFixed(2),y2:p[1].toFixed(2)}));
      });
      leaders.replaceChildren(lines);
      roof.setAttribute('aria-pressed',String(cutaway));
      roof.textContent=cutaway ? roof.dataset.restoreLabel : roof.dataset.revealLabel;
      buttons.forEach(button=>button.setAttribute('aria-expanded',String(notes.find(note=>note.id===button.getAttribute('aria-controls')).open)));
      status.textContent=(cutaway ? model.dataset.statusOpen : model.dataset.statusClosed).replace('{angle}',String((angle+320)%360));
    };
    const select = feature => {
      selected=feature;cutaway=feature==='gallery'||feature==='decoration';
      notes.forEach(note=>{note.open=note.dataset.chapelNote===feature;});render();
    };
    buttons.forEach(button=>button.addEventListener('click',()=>select(button.dataset.chapelFeature)));
    model.querySelectorAll('[data-chapel-turn]').forEach(button=>button.addEventListener('click',()=>{
      angle=(angle+Number(button.dataset.chapelTurn)*30+360)%360;render();
    }));
    roof.addEventListener('click',()=>{cutaway=!cutaway;render();});
    notes.forEach(note=>note.addEventListener('toggle',()=>{
      if (note.open && selected!==note.dataset.chapelNote) select(note.dataset.chapelNote);
      else {
        if (!note.open && selected===note.dataset.chapelNote && !notes.some(item=>item.open)) selected='';
        render();
      }
    }));
    render();
    model.querySelector('[data-chapel-static-labels]')?.setAttribute('hidden','');
    [...buttons,toolbar,status].forEach(control=>{control.hidden=false;});
    model.dataset.chapelReady='true';
    model.dataset.chapelRenderer='photo-informed-v2';
  });
})();

/* Visual feedback only. flow.js owns recipients; interactions.js owns tail play. */
(() => {
  'use strict';
  const reduced = typeof matchMedia === 'function'
    ? matchMedia('(prefers-reduced-motion: reduce)') : null;
  reader.querySelectorAll('[data-beavers-revision]').forEach(duty => {
    const group = duty.querySelector('.dues-tokens');
    const hint = duty.querySelector('.duty-choice-hint');
    if (hint && group && !group.hidden) hint.hidden = false;
  });
  reader.querySelectorAll('[data-beavers-revision] [data-beaver-pose]').forEach(button => {
    if (button.dataset.poseReady === 'true') return;
    const pose = button.querySelector('.duty-pose');
    if (!pose) return;
    button.dataset.poseReady = 'true';
    let feedback;
    const stop = () => { feedback?.cancel(); feedback = null; };
    button.addEventListener('click', () => {
      stop();
      if (reduced?.matches || typeof pose.animate !== 'function') return;
      feedback = pose.animate([
        { transform: 'translateY(0) rotate(0)' },
        { transform: 'translateY(-7px) rotate(-2deg)', offset: .4 },
        { transform: 'translateY(0) rotate(0)' }
      ], { duration: 280, easing: 'ease-out', iterations: 1 });
    });
    button.addEventListener('blur', stop);
    if (reduced?.addEventListener) reduced.addEventListener('change', stop);
  });
})();

/* No analytics, automatic popups, posts or inferred localhost sharing URLs. */
(() => {
 'use strict';
 const safe = value => {
  try { const u = new URL(value); return u.protocol === 'https:' && !u.username && !u.password && !u.port && /\./.test(u.hostname) && !/localhost|\.local$|\.test$|example\.|^\d/.test(u.hostname) ? u.href : null; } catch { return null; }
 };
 reader.querySelectorAll('[data-upe-share]').forEach(root => {
  const url = safe(root.dataset.shareCanonical), title = root.dataset.shareTitle, description = root.dataset.shareDescription;
  const copyUrl = url || safe(root.dataset.shareReviewUrl);
  const status = text => { root.querySelector('[data-share-status]').textContent = text; };
  const image = root.dataset.shareImage;
  const native = root.querySelector('[data-share-device]');
  const fileButton = root.querySelector('[data-share-file]');
  if (navigator.share && url) {
   native.hidden = false;
   native.addEventListener('click', async () => {
    try { await navigator.share({title,text:description,url}); status(root.dataset.shareDone); }
    catch(error) { status(error.name === 'AbortError' ? root.dataset.shareCancelled : root.dataset.shareFailure); }
   });
  }
  if (navigator.share && navigator.canShare && window.File) {
   fileButton.hidden = false;
   fileButton.addEventListener('click', async () => {
    try {
     const response = await fetch(image); if (!response.ok) throw Error('Image unavailable');
     const file = new File([await response.blob()], `Bebrininkai-${reader.dataset.bkLanguage}.jpg`, {type:'image/jpeg'});
     if (!navigator.canShare({files:[file]})) throw Error('File sharing unavailable');
     await navigator.share({files:[file],title,text:description}); status(root.dataset.shareDone);
    } catch(error) { status(error.name === 'AbortError' ? root.dataset.shareCancelled : root.dataset.shareFailure); }
   });
  }
  if (copyUrl) {
   root.querySelector('.upe-share-link').hidden = false;
   const input = root.querySelector('input'); input.value = copyUrl;
   const copy = root.querySelector('[data-share-copy]'); copy.hidden = false;
   copy.addEventListener('click', async () => {
    try { await navigator.clipboard.writeText(copyUrl); status(root.dataset.shareCopied); }
    catch { input.focus(); input.select(); status(root.dataset.shareFailed); }
   });
  }
  if (!url) return;
  root.querySelector('[data-share-notice]').hidden = true;
  const make = (base, args) => `${base}?${new URLSearchParams(args)}`;
  const links = {
   facebook:make('https://www.facebook.com/sharer/sharer.php',{u:url}),
   whatsapp:make('https://wa.me/',{text:`${title}\n${url}`}),
   telegram:make('https://t.me/share/url',{url,text:title}),
   x:make('https://x.com/intent/tweet',{url,text:title})
  };
  // Shopify asset_url commonly emits a protocol-relative CDN URL.
  const media = safe(image?.startsWith('//') ? 'https:' + image : image);
  if (media) links.pinterest = make('https://www.pinterest.com/pin/create/button/',{url,media,description:title});
  root.querySelectorAll('[data-share-network]').forEach(button => {
   const href = links[button.dataset.shareNetwork]; if (!href) return;
   const a = document.createElement('a'); a.href = href; a.innerHTML = button.innerHTML;
   a.target = '_blank'; a.rel = 'noopener noreferrer nofollow'; a.dataset.shareNetwork = button.dataset.shareNetwork; button.replaceWith(a);
  });
 });
})();

})();
